<template>
    <div class="row">
        <go-lotus-side-menu
            :side-menu-items="menuItems"
            @set-parent-prop="propSetFromChild($event)"
        ></go-lotus-side-menu>

        <div class="col-12 col-md-7 main-content position-relative p-3">
            <account-information
                :user="user"
                :organization="organization"
                :titles="titles"
            ></account-information>

            <account-organizations
                :user="user"
                :roles="roles"
                :subscription="subscription"
                :organization="organization"
                :organizations="organizations"
            ></account-organizations>

            <account-managed
                v-if="viewStatus === status.ORGANIZATION_USER"
                :subscription="subscription"
            ></account-managed>

            <account-subscribed
                v-if="viewStatus === status.ORGANIZATION_SUPER_SUBSCRIBED"
                :user="user"
                :selected-plan="selectedPlan"
                :subscription="subscription"
                :preview="preview"
                :plans="plans"
                :is-stripe-mounted="isStripeMounted"
                @subscription-changed="getSubscriptionDetails()"
                @update-preview="getUpcomingInvoicePreview($event)"
            ></account-subscribed>

            <account-grace-period
                v-if="viewStatus === status.ORGANIZATION_SUPER_GRACE_PERIOD"
                :user="user"
                :subscription="subscription"
            ></account-grace-period>

            <account-trial
                v-if="viewStatus === status.ORGANIZATION_SUPER_GENERIC_TRIAL"
                :user="user"
                :subscription="subscription"
                :plans="plans"
                :is-stripe-mounted="isStripeMounted"
                :intent="intent"
                @stripe-mounted="isStripeMounted = true"
                @update-preview="getUpcomingInvoicePreview($event)"
            ></account-trial>

            <account-invoices
                v-if="
                    viewStatus === status.ORGANIZATION_SUPER_SUBSCRIBED ||
                        viewStatus === status.ORGANIZATION_SUPER_GRACE_PERIOD
                "
                :user="user"
                :subscription="subscription"
            ></account-invoices>

            <account-deactivate :user="user" :organization="organization"></account-deactivate>
        </div>
    </div>
</template>

<script>
import GoLotusSideMenu from "./GoLotusSideMenu";
import { sideMenuItems } from "../plugins/sideMenuItems";
import { permissions } from "../plugins/permissions";
import AccountDeactivate from "./account-settings/AccountDeactivate";
import AccountGracePeriod from "./account-settings/AccountGracePeriod";
import AccountInformation from "./account-settings/AccountInformation";
import AccountInvoices from "./account-settings/AccountInvoices";
import AccountManaged from "./account-settings/AccountManaged";
import AccountOrganizations from "./account-settings/AccountOrganizations";
import AccountSubscribed from "./account-settings/AccountSubscribed";
import AccountTrial from "./account-settings/AccountTrial";

export default {
    name: "AccountSettings",
    props: ["user", "organization", "organizations", "roles", "titles", "intent"],
    components: {
        GoLotusSideMenu,
        AccountDeactivate,
        AccountGracePeriod,
        AccountInformation,
        AccountInvoices,
        AccountManaged,
        AccountOrganizations,
        AccountSubscribed,
        AccountTrial,
    },
    mixins: [sideMenuItems, permissions],
    data() {
        return {
            subscription: {},
            invoices: [],
            isStripeMounted: false,
            selectedPlan: "",
            plans: [],
            preview: null,
        };
    },
    computed: {
        status() {
            return {
                ORGANIZATION_USER: 2,
                ORGANIZATION_SUPER_SUBSCRIBED: 33,
                ORGANIZATION_SUPER_GRACE_PERIOD: 44,
                ORGANIZATION_SUPER_GENERIC_TRIAL: 55,
            };
        },

        viewStatus() {
            if (this.subscription) {
                if (this.subscription.is_billing_user) {
                    if (this.subscription.is_on_grace_period) {
                        return this.status.ORGANIZATION_SUPER_GRACE_PERIOD;
                    }
                    if (this.subscription.is_subscribed) {
                        return this.status.ORGANIZATION_SUPER_SUBSCRIBED;
                    } else {
                        return this.status.ORGANIZATION_SUPER_GENERIC_TRIAL;
                    }
                } else {
                    return this.status.ORGANIZATION_USER;
                }
            }
            return 0;
        },
    },

    watch: {
        subscription() {
            if (this.subscription) {
                if (
                    !this.subscription.plan ||
                    (this.subscription.plan &&
                        this.subscription.plan.toLowerCase().includes("silver"))
                ) {
                    this.getBasicPlans();
                }
            }
        },

        user() {
            if (this.user && this.organization && !Object.keys(this.subscription).length) {
                this.getSubscriptionDetails();
            }
        },

        organization() {
            if (this.user && this.organization && !Object.keys(this.subscription).length) {
                this.getSubscriptionDetails();
            }
        },
    },
    methods: {
        getUpcomingInvoicePreview(payload) {
            this.preview = null;
            if (!this.ccCanViewOrganization) return;
            axios
                .get(
                    `api/users/${this.user.id}/subscription/preview?${
                        _.get(this.organization, "id", null)
                            ? `&organization=` + this.organization.id
                            : ``
                    }${payload.plan ? `&plan=${payload.plan}` : ""}${
                        payload.coupon ? `&coupon=${payload.coupon}` : ""
                    }`
                )
                .then(r => {
                    this.preview = r.data;
                    this.preview.plan = payload.plan;
                    this.preview.coupon = payload.coupon;
                });
        },

        getBasicPlans() {
            axios
                .get(`/api/plans`)
                .then(r => {
                    this.plans = r.data;
                })
                .then(() => {
                    let plan = this.plans.find(p => p.id === this.subscription.plan_id);
                    this.selectedPlan = plan ? plan.id : "";
                });
        },

        getSubscriptionDetails() {
            axios
                .get(
                    `/api/users/${this.user.id}/subscription?organization_id=${
                        this.organization.id
                    }`
                )
                .then(r => {
                    this.subscription = r.data;
                    let plan = this.plans.find(p => p.nickname === this.subscription.plan);
                    this.selectedPlan = plan ? plan.id : "";
                    this.preview = null;
                })
                .catch(e => {
                    console.error(e);
                });
        },
    },
};
</script>
